import React, { Component } from "react";
import ImageGallery from "react-image-gallery";
import "react-image-gallery/styles/css/image-gallery.css";
import { connect } from "react-redux";
import LoadS3Keys from "../actions/loadS3Keys";

export class PhotoGallery extends Component {
  constructor(props) {
    super(props);
    const url = window.location.href;
    const queryString = url.substring(url.indexOf("?") + 1, url.length);
    this.props.loadS3Keys(
      queryString.substring(queryString.indexOf("=") + 1, queryString.length)
    );
  }

  render() {
    const images = [];
    this.props.keys.forEach(s3Key => {
      images.push({ original: s3Key, thumbnail: s3Key });
    });

    return (
      <div>
        <ImageGallery items={images} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    keys: state.s3KeysReducer.keys
  };
};

const mapDispatchToProps = dispatch => {
  return {
    loadS3Keys: prefix => dispatch(LoadS3Keys(prefix))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PhotoGallery);
